// extracted by mini-css-extract-plugin
export default {"CoverBadge":"CoverBadge_CoverBadge__fYxQ2","CoverBadge__badge":"CoverBadge_CoverBadge__badge__Qik8K"};